import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var Footer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Footer, _React$Component);

  function Footer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Footer.prototype;

  _proto.render = function render() {
    return React.createElement("footer", {
      className: "footer"
    }, this.props.infoList.map(function (item, index) {
      var linkUrl = item.linkUrl,
          title = item.title;
      return React.createElement("span", {
        className: "info",
        key: "footer-info-" + index
      }, React.createElement("a", {
        href: linkUrl,
        target: "_blank",
        rel: "noreferrer noopener"
      }, title));
    }));
  };

  return Footer;
}(React.Component);

export default Footer;